<template>
  <div>
    <b-row>
      <b-col sm="12" md="12">
        <b-card no-body>
          <b-card-header>
              <h3 class="float-left"><i class='fa fa-user'></i> VIP Level - Settings</h3>
          </b-card-header>
          <b-card-body>
            <b-table v-if="tableShow" :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="items" :fields="fields" :current-page="currentPage" :per-page="perPage">
              <template v-slot:cell(LowStage)="data">
                <span>{{format(data.item.LowStage, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(MediumStage)="data">
                <span>{{format(data.item.MediumStage, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(HighStage)="data">
                <span>{{format(data.item.HighStage, '0,0.00')}}</span>
              </template>
              <template v-slot:cell(OverStage)="data">
                <span>{{format(data.item.OverStage, '0,0.00')}}</span>
              </template>
              <!-- <template v-slot:cell(Display)="data">
                <c-switch ref="displayStatus" type="text" variant="success" on="On" off="Off" :pill="true" :checked="!!(data.item.Display)" @change="showUpdateVipDisplayStatus(data.item.Id, data.item.Display, data.item.Name)"/>
              </template> -->
            </b-table>
            <nav>
              <b-pagination :total-rows="getRowCount(items)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
            </nav>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <!-- <b-modal title="Change Display Status" class="modal-success" v-model="confirmChange" okTitle="Confirm" @ok="updateDisplayStatus" @cancel="cancelUpdateDisplayStatus" ok-variant="success">
      <h5>Are you sure you want to change display status for <strong>{{ changeVipName }}</strong>?</h5>
    </b-modal> -->
  </div>
</template>

<script>
  import cSwitch from '../../../components/Switch'
  import VueNotifications from 'vue-notifications'
  import numeral from 'numeral'
  import {Events} from '../../../events.js'
  export default {
    name: 'vip-level-settings-table',
    props: {
      caption: {
        type: String,
        default: 'Table'
      },
      hover: {
        type: Boolean,
        default: false
      },
      striped: {
        type: Boolean,
        default: false
      },
      bordered: {
        type: Boolean,
        default: false
      },
      small: {
        type: Boolean,
        default: false
      },
      fixed: {
        type: Boolean,
        default: false
      }
    },
    data: () => {
      return {
        items: [],
        fields: [
          {key: 'Id', label: 'ID'},
          {key: 'Name', label: 'Name'},
          {key: 'LowStage', label: 'Low Stage'},
          {key: 'MediumStage', label: 'Medium Stage'},
          {key: 'HighStage', label: 'High Stage'},
          {key: 'OverStage', label: 'Over Stage'},
          {key: 'DailyTransCount', label: 'Daily Trans Count'},
          {key: 'DailyTransAmount', label: 'Daily Trans Amount'},
          {key: 'TotalMembers', label: 'Total Members'}
          // {key: 'Display', label: 'Display'}
        ],
        tableShow: true,
        currentPage: 1,
        perPage: 30,
        changeVipName: '',
        changeId: '',
        changeStatus: '',
        confirmChange: false
      }
    },
    components: {
      cSwitch
    },
    computed: {
      isChecked: {
        get: function (params) {
        },
        set: function (val) {
          console.log(val)
        }
      }
    },
    methods: {
      format (num, fmt) {
        return numeral(num).format(fmt)
      },
      getBadge (status) {
        return status === 1 ? 'success' : 'danger'
      },
      getRowCount (items) {
        return items.length
      },
      getVIPList () {
        this.$http.get(this.API_ENDPOINT + '/payment/viplevel/list', {headers: { 'Content-Type': 'application/json' }}).then(response => {
          this.items = response.data.list
        }).catch(err => {
          console.log('this is an error ', err)
          Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
        })
      }
      // showUpdateVipDisplayStatus (id, status, name) {
      //   this.changeId = id
      //   this.changeStatus = !status
      //   this.changeVipName = name
      //   this.confirmChange = true
      // },
      // cancelUpdateDisplayStatus () {
      //   this.tableShow = false
      //   this.changeId = ''
      //   this.changeStatus = ''
      //   this.changeVipName = ''
      //   this.confirmChange = false
      //   setTimeout(() => { this.tableShow = true }, 0)
      // },
      // updateDisplayStatus () {
      //   this.$http.put(this.API_ENDPOINT + '/payment/viplevel/display/' + this.changeId, {
      //     display: this.changeStatus
      //   }, {
      //     header: { 'Content-Type': 'application/json' }
      //   }).then(async response => {
      //     await this.getVIPList()
      //     this.cancelUpdateDisplayStatus()
      //     Events.$emit('alert', VueNotifications.types.success, 'Success', 'Display Changed successfully.')
      //   }).catch(err => {
      //     console.log('this is an error ', err)
      //     Events.$emit('alert', VueNotifications.types.error, 'Error', 'Something went wrong')
      //   })
      // }
    },
    created () {
      this.getVIPList()
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/payment/viplevel/VIPLevelSettingsTable.vue